export default __webpack_public_path__ + "static/media/30_wabbit.b6336fdf.png";